import { render, staticRenderFns } from "./EmptyColumns.vue?vue&type=template&id=18aff380&"
import script from "./EmptyColumns.vue?vue&type=script&lang=ts&"
export * from "./EmptyColumns.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports